import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import TextAnim from '../Text/_TextAnim';
import HebiAnim from '../Hebi/_HebiAnim';
import UiScroll from '../Ui/_UiScroll';
import UiBtnRestart from '../Ui/_UiBtnRestart';
// import End from '../End/_EndAnim';


gsap.registerPlugin(ScrollTrigger);

// import End from '../End/_EndAnim';

export class ManagePage {

  static maxPageNum = 7;
  static currentPageNum = 0;
  static leaveNum = 0;
  static isScene7 = false;

  static textAnim = new TextAnim();
  static hebiAnim = new HebiAnim();
  static uiScroll = new UiScroll();
  static uiBtnRestart = new UiBtnRestart();
  // static end = new End();

  static init() {
    $('html,body').animate({ scrollTop: 0 }, 100, function() {
      $('body').addClass('body--overflow');
      $('.cover').hide();
    });
  }

  static reLoad() {
    location.reload();
  }

  static setPage(num) {
    this.leaveNum = this.getCurrentPageNum();

    // ページマネージャーに登録
    this.setCurrentPageNum(num);
    this.currentPageNum = num;

    // if(this.leaveNum != this.currentPageNum) {
    this.textAnim.removeAni(this.getCurrentPageNum());
    this.textAnim.setAni(this.getCurrentPageNum());
    this.hebiAnim.setAni(this.getCurrentPageNum());
    this.uiScroll.setScroll(this.getCurrentPageNum());
    this.changeUi(this.currentPageNum);
    this.setBodyClass();

    // if (num == 7) {
    //   this.end.setScrollTrigger();
    //   if(!this.isScene7) {
    //     this.isScene7 = true;
    //   }
    // } else if (num != 7 && this.isScene7) {
    //   this.end.killScrollTrigger();
    // }

    // }
    this.setGuide();
  }

  static changeUi(num) {
    // end
    if (num == 7) {
      $('body').removeClass('body--overflow');
      $('.mainContent').addClass('mainContent--relative');
    } else {
      $('body').addClass('body--overflow');
      $('.mainContent').removeClass('mainContent--relative');
    }
  }

  static setBodyClass() {
    // $('body').addClass('pageid--' + this.currentPageNum);
    $('body').attr('data-page-id', this.currentPageNum);


    ScrollTrigger.refresh();
  }

  static getCurrentPageNum() {
    return this.currentPageNum;
  }

  static setCurrentPageNum(num) {
    this.currentPageNum = num;
  }

  static gotoNextPage() {
    if (!this.textAnim.isCompleted()) return false;

    this.currentPageNum++;
    if (this.currentPageNum > this.maxPageNum) this.currentPageNum = this.maxPageNum;
    this.setPage(this.currentPageNum);
  }

  static gotoPrevPage() {
    if (!this.textAnim.isCompleted() || this.currentPageNum == 1) return false;

    this.currentPageNum--;
    if (this.currentPageNum < 1) this.currentPageNum = 1;
    this.setPage(this.currentPageNum);
  }

  static setGuide() {
    $('.guide__strPage').html(this.getCurrentPageNum());
  }

}
